var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockThin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 7C15.1111 7 7.49997 14.6112 7.49997 24C7.49997 33.3888 15.1111 41 24.5 41C33.8888 41 41.5 33.3888 41.5 24C41.5 14.6112 33.8888 7 24.5 7ZM5.49997 24C5.49997 13.5066 14.0066 5 24.5 5C34.9934 5 43.5 13.5066 43.5 24C43.5 34.4934 34.9934 43 24.5 43C14.0066 43 5.49997 34.4934 5.49997 24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 13C25.0523 13 25.5 13.4477 25.5 14V23.5858L31.2071 29.2929C31.5976 29.6834 31.5976 30.3166 31.2071 30.7071C30.8166 31.0976 30.1834 31.0976 29.7929 30.7071L23.7929 24.7071C23.6053 24.5196 23.5 24.2652 23.5 24V14C23.5 13.4477 23.9477 13 24.5 13Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockThin);
export default __webpack_public_path__ + "static/media/clock-thin.8d8675fd.svg";
export { ForwardRef as ReactComponent };